import React from 'react';
import { TimePicker } from '@material-ui/pickers';
import * as Types from 'pages/Features/tabs/Profile/TimezoneAndWorkHours/typings';

import classNames from 'classnames';
import makeStyles from '@material-ui/styles/makeStyles';
import Typography from '@material-ui/core/Typography';

interface Props {
  clearable: boolean;
  startTime: any;
  endTime: any;
  disabled?: boolean;
  error: any;
  onChangeStartTime: (time: any) => void;
  onChangeEndTime: (time: any) => void;
}

function WorkHoursSelector({
  clearable,
  startTime,
  endTime,
  disabled = false,
  error,
  onChangeStartTime,
  onChangeEndTime,
}: Props) {
  const classes = useStyles();
  const hasError = !!error;

  return (
    <div className={classes.root}>
      <div className={classes.timePickerWrapper}>
        <div className={classes.timePickerContainer}>
          <TimePicker
            clearable={clearable}
            aria-label="Select start time"
            inputProps={{ 'aria-label': 'start time' }}
            value={startTime || null}
            disabled={disabled}
            onChange={onChangeStartTime}
            className={classNames(classes.timePicker, { [classes.inputErred]: hasError })}
          />
          <Typography>to</Typography>
          <TimePicker
            clearable={clearable}
            aria-label="Select end time"
            inputProps={{ 'aria-label': 'end time' }}
            value={endTime || null}
            disabled={disabled}
            onChange={onChangeEndTime}
            className={classNames(classes.timePicker, { [classes.inputErred]: hasError })}
          />
        </div>
      </div>
    </div>
  );
}

const useStyles = makeStyles((theme: any) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  timePickerWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  timePickerContainer: {
    display: 'flex',
    alignItems: 'center',
    width: 240,
    justifyContent: 'space-around',
  },
  timePicker: {
    width: 80,
  },
  inputErred: {
    '& input': {
      color: theme.palette.error.main,
    },
  },
}));

export default WorkHoursSelector;
